import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PAGE_NAMES } from 'appenv';

import SearchResultContainer from './SearchResultContainer';

const RootContainer = styled.div`
  width: 100%;
`;

const StyledSectionTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  color: #999;
  margin: 8px 16px;
`;

const AllSearchResultContainer = ({
  showResult,
  exhibitors,
  webinars,
}) => (
  <RootContainer>
    {
      showResult && (
        <>
          <StyledSectionTitle>
            {PAGE_NAMES.exhibitors}
          </StyledSectionTitle>
          <SearchResultContainer
            type="exhibitor"
            results={exhibitors}
          />
          <StyledSectionTitle>
            {PAGE_NAMES.webinar}
          </StyledSectionTitle>
          <SearchResultContainer
            type="webinar"
            results={webinars}
          />
        </>
      )
    }
  </RootContainer>
);

AllSearchResultContainer.propTypes = {
  showResult: PropTypes.bool,
  exhibitors: PropTypes.arrayOf(PropTypes.shape()),
  webinars: PropTypes.arrayOf(PropTypes.shape()),
};

AllSearchResultContainer.defaultProps = {
  showResult: false,
  exhibitors: [],
  webinars: [],
};

export default AllSearchResultContainer;
